import { Slice, createSlice } from "@reduxjs/toolkit";
import { fetchSiteMaintenanceTable } from "../thunk/SitesOverviewThunk";

const initialData: any = [];

const SiteMaintenanceTableSlice: Slice<any, {}, "SiteMaintenanceTable"> = createSlice({
    name: "SiteMaintenanceTable",
    initialState: { data: initialData, isLoading: false, error: "" },
    reducers: {},
    extraReducers(builder) {
        builder.addCase(fetchSiteMaintenanceTable.pending, (state, action) => {
            state.isLoading = true
        });
        builder.addCase(fetchSiteMaintenanceTable.fulfilled, (state, action) => {
            state.isLoading = false
            state.data = action.payload
        });
        builder.addCase(fetchSiteMaintenanceTable.rejected, (state, action) => {
            state.isLoading = false
            state.error = action.error.message ?? ""
        });
    }
})

export default SiteMaintenanceTableSlice
